import { ODataHeader, ODataString, ODataBoolean } from "pbas-vue-components";
import { translate } from "../trans";
import store from "@/store";
import { tokens } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";

const telephoneMask= "(###) ### - ####";
const ContactsHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    title: "headers.members_management.Title",
    type: new ODataString("Title/Name", {
      getString: (item) => {
        if (!item) return "";
        const lang = store.getters["common/language"];
        return translate(item.Title, lang.language);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("Title/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("TitleId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Name"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.contacts.email",
    type: new ODataString("Email"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.locals.phone_number",
    type: new ODataString("PhoneNumber", {
      getString: (item) => {
        if (item.PhoneNumber) {
          return masker(item.PhoneNumber, telephoneMask, true, tokens);
        }
        return "";
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.fax_number",
    type: new ODataString("Fax", {
      getString: (item) => {
        if (item.Fax) {
          return masker(item.Fax, telephoneMask, true, tokens);
        }
        return "";
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.status",
    type: new ODataString("Status/Name", {
      getString: (item) => {
        if (!item) return "";
        const lang = store.getters["common/language"];
        return translate(item.Status, lang.language);
      },
    }),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataString("Status/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.status",
    type: new ODataString("Status/Translations[]/DisplayValue", {
      getString: (item) => {
        if (!item) return "";
        const lang = store.getters["common/language"];
        return translate(item.Status, lang.language);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
    version: 2,
    orderByKey: "Status/Name",
  }),
  new ODataHeader({
    type: new ODataString("Status/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("StatusId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "components.plancreationwizard.primary",
    type: new ODataBoolean("IsPrincipal"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IsInHouse"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
export default ContactsHeaders;
